module.exports = __webpack_public_path__ + "media/src/images/zu_exp_02-a01acf19c1783fad1cd897973c7904ad.gif";